import React from "react";
import GalleryLayout from "./GalleryLayout";
import ThumbnailLayout from "./ThumbnailLayout";
import SpeakerLayout from "./SpeakerLayout";
import SideLayout from "./SideLayout";
import { ParticipantType, ShowLayout } from "@/types";

interface PropType {
  participants?: ParticipantType[];
  layout: ShowLayout;
}

const Content: React.FC<PropType> = (props: PropType) => {
  const { layout } = props;
  console.log(`[Content] layout=${layout}`);
  if (layout === ShowLayout.Speaker) {
    return <SpeakerLayout />;
  }
  if (layout === ShowLayout.Thumbnail) {
    return <ThumbnailLayout />;
  }
  if (layout === ShowLayout.Side) {
    return <SideLayout />;
  }
  return <GalleryLayout />;
};

export default Content;
